import React, { useState, useEffect, useCallback, useRef } from "react";
import { Animated, View } from "react-native";

import Icons from "../../common/icons/index";
import TimeSlotItemEndTime from "./time/TimeSlotItemEndTime";
import TimeSlotItemStartTime from "./time/TimeSlotItemStartTime";
import { isSleep } from "../../../../helpers/utils";
import appStyles from "../../../appStyles";
import TutorialsHelper from "../../tutorials/TutorialsHelper";

export default function TimeSlotItemTimes(props) {
  const {
    timeslot,
    journalContext,
    prevTimeslot,
    positionIndex,
    editMode,
    isHomeCard = false,
    showEndTime = false,
    timeslotModel,
  } = props || {};

  const {
    controller,
    onTimeslotSelected = () => {},
    toggleTimePicker = () => {},
    tutorialStep,
    onTutorialTimePickerOpen = () => {},
    firstUnconfirmedId,
    isBulkEdit,
  } = journalContext || {};

  const [highlightSleepStyle, setHighlightSleepStyle] = useState(null);
  const [highlightMoreStyle, setHighlightMoreStyle] = useState(null);

  // ------------------------------------- TUTORIALS -------------------------------------
  const showTrackTutorials = (controller?.state?.showTutorials || {})[
    TutorialsHelper.STORAGE_KEYS.track
  ];

  useEffect(() => {
    setHighlightSleepStyle(
      tutorialStep == 2 && isSleep(timeslotModel?.activity?.name)
        ? appStyles.highlightRound
        : null,
    );
  }, [timeslotModel]);

  useEffect(() => {
    setHighlightMoreStyle(
      tutorialStep == 4 &&
        timeslot?.id &&
        timeslot.id.includes(firstUnconfirmedId)
        ? appStyles.highlightRound
        : null,
    );
  }, [firstUnconfirmedId]);

  let hasEditableTime = !editMode && timeslotModel && timeslotModel.activity;

  if (!isHomeCard) {
    hasEditableTime =
      !editMode &&
      timeslotModel &&
      (timeslotModel.activity || timeslotModel.user_confirmed);
  }

  const openTimePicker = () => {
    if ((showTrackTutorials && !highlightSleepStyle) || isBulkEdit) return;
    toggleTimePicker(timeslotModel);
    onTutorialTimePickerOpen();
  };

  // Don't render anything
  if (!timeslotModel) {
    return null;
  }

  return (
    <View style={appStyles.timeslotControls}>
      <TimeSlotItemStartTime
        prevTimeslot={prevTimeslot}
        timeslot={timeslotModel}
        index={positionIndex}
        onPress={timeslot.isSelected ? () => {} : null}
      />

      {showEndTime ? (
        <TimeSlotItemEndTime
          timeslot={timeslotModel}
          onPress={timeslot.isSelected ? () => {} : null}
        />
      ) : null}

      {/* Time picker */}
      {hasEditableTime ? (
        <Icons.ChangeTimeIcon
          onPress={isBulkEdit ? null : openTimePicker}
          style={[
            appStyles.iconContainer,
            appStyles.timeslotControlIcon,
            highlightSleepStyle,
            isBulkEdit ? { opacity: 0.3 } : {},
          ]}
        />
      ) : !editMode &&
        !timeslotModel.activity &&
        timeslotModel.predicted_activities &&
        !timeslotModel.hidePredictions ? (
        <Icons.More
          onPress={() => {
            if (!showTrackTutorials || highlightMoreStyle)
              onTimeslotSelected(timeslot);
          }}
          style={[
            appStyles.iconContainer,
            appStyles.timeslotControlIcon,
            highlightMoreStyle,
          ]}
        />
      ) : null}
    </View>
  );
}
